<template>
    <div>
        <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-document-orders'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-document-orders"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :items="myProvider"
          :fields="fields"
          :empty-text="$t('No matching records found')"
        >
          <template #cell(document_info)="data">
            <div>
                <span class="text-success">COD: </span>
                {{data.item.serie + "-" + data.item.number}}
            </div>             
            <div v-if="data.item.so_code != null">
                <span class="text-success">COS: </span>
                {{data.item.so_code}}
            </div>         
          </template>
          <template #cell(origin)="data">
            <div v-if="data.item.customer_load_reference">
                <span class="text-primary">{{data.item.customer_load_reference}}</span>
            </div>
            <div v-if="data.item.load_date">
                <feather-icon
                  icon="CalendarIcon"
                  size="15"
                  class="text-success"
                />
                <span class="text-warning"> {{data.item.load_date}}</span>
            </div>
          </template>
          <template #cell(destination)="data">
            <div v-if="data.item.customer_destination_name">
                <span class="text-primary">{{data.item.customer_destination_name}}</span>
            </div>
            <div>
                {{data.item.destination_address}}
            </div>
            <div v-if="data.item.destination_code">
                <feather-icon
                  icon="HashIcon"
                  size="15"
                  class="text-info"
                />
                <span class="text-info">Cód. destino: </span>{{data.item.destination_code}}
            </div>
            <div v-if="data.item.delivery_point_code">
                Cód. entrega: {{data.item.delivery_point_code}}
            </div>
            <div v-if="data.item.locality">
               Localidad: {{data.item.locality}}
            </div>
            <div v-if="data.item.required_delivery_date">
                <feather-icon
                  icon="CalendarIcon"
                  size="15"
                  class="text-success"
                />
                <span class="text-warning"> {{data.item.required_delivery_date}}</span>
            </div>
          </template>
          <template #cell(transport_info)="data">
            <div v-if="data.item.transport_number">                
                <feather-icon
                  icon="ArchiveIcon"
                  size="15"
                  class="text-primary"
                />
                N° transporte: {{data.item.transport_number}}
            </div>
            <div v-if="data.item.vehicle_plate">
                <feather-icon
                  icon="TruckIcon"
                  size="15"
                  class="text-info"
                />
                Placa: {{data.item.vehicle_plate}}
            </div>
            <div>
                {{data.item.service_order_code}}
            </div>     
          </template>
          <template #cell(codes)="data">
            <div v-if="data.item.delivery_number">
                N° entrega: <span class="text-warning">{{data.item.delivery_number}}</span>
            </div>
            <div v-if="data.item.remittance_number">
                N° remesa: <span class="text-warning">{{data.item.remittance_number}}</span>
            </div>
          </template>
          <template #cell(observations)="data">
            {{data.item.observations}}
          </template>
          <template #cell(actions)="data">
            <div v-if="data.item.is_travel_finished">
                <feather-icon
                icon="EyeIcon"
                class="cursor-pointer text-success"
                @click="orderDocumentModal(data.item)"
                />            
            </div>
            <div v-else>
                <feather-icon            
                icon="MinusCircleIcon"
                class="cursor-pointer text-danger"            
                @click="deleteDocument(data.item)"
                />
                <feather-icon
                icon="EditIcon"
                class="cursor-pointer text-warning ml-1"
                @click="orderDocumentModal(data.item)"
                />
            </div>
          </template>
        </b-table>
      </template>
    </filter-slot>
        <document-order-modal
        v-if="showModal"
        :documentOrderId="documentOrderId"
        @hideModal="closeModal()"
        @refreshTable="refreshTable()"
        />
    </div>
</template>
<script>
import DocumentOrderService from "@/views/operations/views/document-orders/services/document-orders.service.js";
import Fields from "@/views/operations/views/document-orders/data/document-orders-grid.fields.js";
import DocumentOrderModal from "@/views/operations/views/document-orders/modals/DocumentOrderModal.vue";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Filters from "@/views/operations/views/document-orders/data/document-order.filters.js";
import { mapGetters } from 'vuex'
export default {
    components:{
        DocumentOrderModal,
        FilterSlot,
    },
    data(){
        return {
            fields: Fields,
            showModal: false,
            documentOrderId: null,
            filters: Filters,
            filterPrincipal: {
                type: "input",
                inputType: "text",
                placeholder: "Search...",
                model: "",
            },
            paginate: {
                from: 0,
                to: 0,
                of: 0,
                perPage: 10,
                currentPage: 1,
            },
        }
    },
    computed:{
        ...mapGetters({
            currentUser: "auth/currentUser"
        })
    },
    methods:{
        async myProvider(){
            const params = {
                page: this.paginate.currentPage,
                perpage: this.paginate.perPage,
                search: this.filterPrincipal.model,
                from: this.filters[0].model,
                to: this.filters[1].model,
                fromLoad: this.filters[2].model,
                toLoad: this.filters[3].model,
                fromDelivery: this.filters[4].model,
                toDelivery: this.filters[5].model,
            };
            console.log(params)
            const { data } = await DocumentOrderService.getDocumentOrders(params);
            this.paginate.from = data.from;
            this.paginate.to = data.to;
            this.paginate.of = data.total;
            this.paginate.perPage = data.per_page;
            this.paginate.currentPage = data.current_page;
            return data.data
        },
        async orderDocumentModal(item){
            this.documentOrderId = item.id;
            this.showModal = true;
        },
        async deleteDocument(item){
            const confirm = await this.showConfirmSwal();
            if (!confirm.isConfirmed) return;
            const params = {
                id: item.id,
                document_order_id: item.id,
                module_id: this.currentUser.modul_id,
                section_id: this.$route.meta.section,
                serie: item.serie,
                number: item.number,
                user_id: this.currentUser.employee_id
            }
            try {
                this.addPreloader();
                const { data } = await DocumentOrderService.deleteDocument(params)
                if(data.success){
                    this.refreshTable();
                    this.showToastSuccess("Successfull process");
                }else{
                    this.showToastWarning("Error process");
                }        
            } catch (error) {
                this.showToastError(error);
            } finally {
                this.removePreloader();
            }
        },
        refreshTable(){
            this.$refs['ref-table-document-orders'].refresh();
        },
        closeModal(){
            this.showModal = false;
        }
    }
}
</script>